import React from "react";

import MotorcycleIcon from '@material-ui/icons/MotorcycleRounded';
import PinIcon from "./SVGs/PinIcon";
import HomeIcon from "./SVGs/HomeIcon";

export default class iconColors {
    constructor() {
        const iconColors = [
            '#B0B0B0',
            '#2b9b2b',
            '#6495ed',
            '#FFD300',
            '#CC5500',
            '#ee82ee',
            '#48D1CC',
            '#9fa91f',
            '#0048BA',
            '#FFFF99',
            '#474747',
            '#841B2D',
            '#54ff9f',
            '#F400A1',
            '#ffa54f',
            '#8B008B',
            '#ff0012',
            '#fbffff'
        ];

        this.icons = this.createIconColors(iconColors);

        this.appendIcons();
        this.groupToColor = {};
    }

    createIconColors(iconColors) {
        return iconColors.map((color, index) => {
            return {
                colorIndex: index,
                primaryColor: color,
                secondaryColor: this.pSBC(-0.2, color),
                thirdColor: this.pSBC(-0.4, color)
            }
        });
    }

    pSBC(p, c0, c1, l) {
        let r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
        if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
        if (!this.pSBCr) this.pSBCr = (d) => {
            let n = d.length, x = {};
            if (n > 9) {
                [r, g, b, a] = d = d.split(","), n = d.length;
                if (n < 3 || n > 4) return null;
                x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
            } else {
                if (n == 8 || n == 6 || n < 4) return null;
                if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
                d = i(d.slice(1), 16);
                if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
                else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
            }
            return x
        };
        h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? {
            r: 0,
            g: 0,
            b: 0,
            a: -1
        } : {r: 255, g: 255, b: 255, a: -1}, p = P ? p * -1 : p, P = 1 - p;
        if (!f || !t) return null;
        if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
        else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
        a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
        if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
        else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
    }

    appendIcons() {
        this.icons.forEach(colorPalette => {
            colorPalette.pinIcon = this.getPinSvgWithColor(colorPalette.primaryColor, colorPalette.secondaryColor, colorPalette.thirdColor);
            colorPalette.messengerIcon = this.getMessengerSvgWithColor(colorPalette.primaryColor);
        })
    }

    getMessengerSvgWithColor(color) {
        return <MotorcycleIcon style={{color, stroke: '#0000007a'}}/>
    }

    getPinSvgWithColor(primaryColor, secondaryColor, thirdColor) {
        return (
            <PinIcon primaryColor={primaryColor}
                     secondaryColor={secondaryColor}
                     thirdColor={thirdColor}
            />
        )
    }

    getHomeSvgWithColor(color) {
        return <HomeIcon/>
    }

    getPinIconByGroupId(groupId) {
        if (!this.groupToColor[groupId])
            return this.icons[0].pinIcon;
        return this.icons[this.groupToColor[groupId]].pinIcon;
    }

    getColorByGroupId(groupId) {
        if (!this.groupToColor[groupId])
            return this.icons[0];

        return this.icons[this.groupToColor[groupId]];
    }

    getMessengersIconByGroupId(groupId) {
        if (!this.groupToColor[groupId])
            return this.icons[0].messengerIcon;
        return this.icons[this.groupToColor[groupId]].messengerIcon;
    }

    assignGroupToColor(groupId) {
        if (this.groupToColor[groupId]) return;

        this.groupToColor[groupId] = this.getAvailableColorIndex();
    }

    revokeGroupFromColor(groupId) {
        delete this.groupToColor[groupId];
    }

    getAvailableColorIndex() {
        const takenIndices = Object.values(this.groupToColor);

        for (let i = 1; i < this.icons.length; i++) {
            if (!takenIndices.includes(i))
                return i;
        }

        return 0;
    }

    getAvailableColor() {
        return this.icons[this.getAvailableColorIndex()];
    }

    getAssignedGroups() {
        return Object.keys(this.groupToColor);
    }
}